/** @format */

import React, { useContext, useState, useEffect } from "react";

import {
  List,
  ListItemIcon,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Box,
  Typography,
  Tooltip,
} from "@material-ui/core";

import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import Drawer from "@material-ui/core/Drawer";

import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
//import LogoPCH from '/static/imagen/LogoPCH.png'
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { Link } from "react-router-dom";
import MailIcon from "@material-ui/icons/Mail";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { AuthContext } from "../../context/Globales/AuthContext";
import { types } from "../../context/types";
import Loading from "../modales/Loading";
import UserContext from "../../context/Globales/UserContext";
import { v4 as uuid } from "uuid";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { DecodificanString } from "../../helpers/Codifican";
import HomeIcon from "@material-ui/icons/Home";
import { isMobile } from "react-device-detect";

const drawerWidth = 310;

const useStyle = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaper: {
    link: {
      textDecoration: "none",
      color: theme.palette.text.primary,
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7), // espacio del sidebar cuando esta oculto(hace que se vean solo los iconos)
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(8), // espacio del sidebar cuando sube del tamaño sm( el padding ancho se agranda)
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar, // alinea la linea del sidebar con la del navbar
  },
  content: {
    display: "flex",
    padding: theme.spacing(9),
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.primary.main,
  },
  largeAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },

    hide: {
    display: 'none',
  },
}));

const Listas = ({ open, handleDrawerClose }) => {
  const {
    user: { name },
  } = useContext(AuthContext);
  //const {user:{name}} = useContext(UserContext);
  const { dispatch } = useContext(AuthContext);

  const NombeUser = DecodificanString(JSON.parse(localStorage.getItem("name")));
  const ClienteId = DecodificanString(
    JSON.parse(localStorage.getItem("clientId"))
  );
  const ContractId = DecodificanString(
    JSON.parse(localStorage.getItem("contractId"))
  );

  const { DataPermisos, DataTipoContracto, DataProducts } =
    useContext(UserContext);

  const userContext = useContext(UserContext);
  const datosPermisos = JSON.parse(localStorage.getItem("datosPermisos"));
  const theme = useTheme();
  const classes = useStyle();
  const [OpenLoading, setOpenLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [maxAncho, setAncho] = useState(null);
  const abrir = Boolean(anchorEl);
  const path = String(maxAncho);

  const DataUrl = DecodificanString(
    JSON.parse(localStorage.getItem("urlBaseHome"))
  );

  // const dataSetConditions = JSON.parse(localStorage.getItem('setConditionsProducts'));

  const DataUrlLink =
    DataUrl + "?SKL=" + JSON.parse(localStorage.getItem("skl"));

  useEffect(() => {
    userContext.getTipoContracto(ClienteId, ContractId);
  }, [ClienteId, ContractId]);

  const handleLogout = (e) => {
    setOpenLoading(true);

    localStorage.clear();

    dispatch({ type: types.AuthLogout });

    // window.location.href=parametros.rutaServidor +"login";

    setOpenLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutUrl = (e) => {
    setOpenLoading(true);
    localStorage.setItem("autenticadoTwo", JSON.stringify("retorna"));
    // window.location.href=`${DataUrlLink}`

    if (DataUrl) {
      window.location.href = `${DataUrlLink}`;
    }
    setTimeout(() => {
      // localStorage.clear();

      return (
        JSON.parse(localStorage.getItem("user")) || {
          logged: false,
        }
      );
    }, 1500);

    dispatch({
      type: types.AuthLogout,
    });

    setOpenLoading(false);
  };

  return (
    <>
      {/* <BrowserRouter> */}
      {OpenLoading ? <Loading /> : null}
      <Drawer
        variant={!isMobile ? 'permanent' : 'persistent' }
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <img
            src={process.env.PUBLIC_URL + "/static/imagen/logoPortal.png"}
            title="Logo Portal Cheque"
            alt="Logo Portal Cheque"
            style={{ width: "250px", height: "64px" }}
          />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}{" "}
            {/*direccion de la flecha del sidebar. si es de derecha a izquierda right to left*/}
          </IconButton>
        </div>
        <Divider />

        <List>
          <ListItem button>
            <ListItemIcon alignitems="flex">
              <img
                src={process.env.PUBLIC_URL + "/static/imagen/userLogin.jpg"}
                className={(classes.avatar, classes.largeAvatar)}
                width="100px"
                title="User Icono"
                alt="User Icono"
              />
            </ListItemIcon>
            <Typography className={classes.name} color="primary" variant="h6">
              {" "}
              <Typography color="textSecondary">
                {" "}
                Conectado(a) como:{" "}
              </Typography>{" "}
              {NombeUser} <br />
              <Box my={1} spacing={2}>
                {isMobile && DataProducts && DataProducts.length > 0 ? (
                  <Button
                    onClick={handleLogoutUrl}
                    variant="outlined"
                    color="primary"
                    size="small"
                  >
                    {" "}
                    <ArrowBackIcon /> &nbsp; Ir a principal{" "}
                  </Button>
                ) : (
                  <Button
                    onClick={handleLogout}
                    variant="outlined"
                    color="secondary"
                    size="small"
                  >
                    {" "}
                    Cerrar Sesión{" "}
                  </Button>
                )}
              </Box>
            </Typography>
          </ListItem>

          <Divider />

          {DataTipoContracto && DataTipoContracto.IsPrepago ? (
            <>
              <Link
                to="/viewsaldo"
                style={{ textDecoration: "none", color: "black" }}
                color="secondary"
                key={uuid()}
              >
                <Tooltip title={DataTipoContracto.Nombre}>
                  <ListItem button>
                    <ListItemIcon>
                      {" "}
                      <AccountBalanceWalletIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Tú Plan Actual: <br />{" "}
                      <p style={{ fontSize: "9px" }}>
                        {DataTipoContracto.Nombre}
                      </p>
                    </ListItemText>
                  </ListItem>
                </Tooltip>
              </Link>

              <Divider hidden={DataTipoContracto.IsPrepago ? false : true} />
            </>
          ) : (
            ""
          )}
          {datosPermisos?.map((item) =>
            item.details.map((items) =>
              items.name != "Informe Comercial Multiples Rut" ? (
                <Link
                  to={items.url}
                  style={{ textDecoration: "none", color: "black" }}
                  color="secondary"
                  key={uuid()}
                >
                  <Tooltip
                    title={
                      items.name == "Registro de Acceso"
                        ? "Administracion"
                        : items.name
                    }
                  >
                    <ListItem button>
                      <ListItemIcon>
                        {items.name == "Informes Comerciales" ? (
                          <>
                            {" "}
                            <LibraryBooksIcon />{" "}
                          </>
                        ) : /* items.name == 'Informe Comercial Multiples Rut' ? <FindInPageIcon/> : */
                        items.name == "Soporte" ? (
                          <MailIcon />
                        ) : items.name == "Verificacion Cheque y ONP" ? (
                          <CheckCircleIcon />
                        ) : (
                          items.name == "Registro de Acceso" && (
                            <SupervisorAccountIcon />
                          )
                        )}
                      </ListItemIcon>

                      <ListItemText
                        primary={
                          items.name == "Registro de Acceso"
                            ? "Administracion"
                            : items.name
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )
            )
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Listas;
